import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchFieldOptions } from "../slices/fieldOptionsSlice";

export const useGetUpdateFieldOptions = () => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const loadingStatus = useSelector((state) => state.fieldOptions.loadingStatus);
    const rawFieldList = useSelector((state) => state.fieldUpdateList.categories);

    useEffect(() => {
        if (!token) return;

        const rawFields = Array.isArray(rawFieldList)
            ? rawFieldList.flatMap(c => c.fields || [])
            : [];

        rawFields
            .filter(f => typeof f?.options === 'string' && !loadingStatus[f.name])
            .forEach(f => {
                dispatch(fetchFieldOptions({ fieldName: f.name, url: f.options, token }));
            });
    }, [rawFieldList, token, loadingStatus, dispatch]);

    const loading = Object.values(loadingStatus).some((s) => s === "loading");

    return { loading }
}